import FeatureActivitiesLinks from "components/feature-links/feature-linked-activities";
import FeatureMaterialsLinks from "components/feature-links/feature-linked-materials";
import { ProjectPermissionEnum } from "constants/index";
import {
  isPermissionNotGrantted,
  ProjectContext,
  TProjectContext
} from "context/ProjectProvider";
import { TFetureDetailUpdateAction } from "entity-app/models";
import { useContext } from "react";
import "components/feature-links/feature-links.scss";

export function SubmittalDetailLinks(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  canEditLinkingPage: boolean;
  isRevisionMode: boolean;
  isVoidSubmittal: boolean;
  isDeletedSubmittal: boolean;
}) {
  const {
    featureInstanceData,
    actions,
    canEditLinkingPage,
    isRevisionMode,
    isVoidSubmittal,
    isDeletedSubmittal
  } = props;
  const { tokenContents }: TProjectContext = useContext(ProjectContext);

  const canEditMaterialFields: boolean = !isPermissionNotGrantted(
    ProjectPermissionEnum.InlineEditMaterialPrimaryFields,
    tokenContents?.role!
  );
  return (
    <div className="feature-links-card" data-testid="sdl-root">
      <FeatureMaterialsLinks
        featureInstanceData={featureInstanceData}
        canEditLinkingPage={canEditLinkingPage}
        actions={actions}
        canEditMaterialFields={canEditMaterialFields}
        isRevisionMode={isRevisionMode}
        isVoidSubmittal={isVoidSubmittal}
        isDeletedSubmittal={isDeletedSubmittal}
        data-testid="sdl-materials-links"
      />
      <FeatureActivitiesLinks
        featureInstanceData={featureInstanceData}
        canEditLinkingPage={canEditLinkingPage}
        isRevisionMode={isRevisionMode}
        isVoidSubmittal={isVoidSubmittal}
        isDeletedSubmittal={isDeletedSubmittal}
        data-testid="sdl-activities-links"
      />
    </div>
  );
}
